export enum NotificationTypes {
    Warning ,
    Danger ,
    Successfully
}

export default NotificationTypes